import { Component, Vue, namespace } from 'nuxt-property-decorator';
import { OrganizationDto, isValidGuid } from 'fourwaves-shared';

const OrganizationsModule = namespace('organizations');
const EventsModule = namespace('events');
@Component({
  validate({ params }) {
    return isValidGuid(params.id);
  },
})
export default class OrganizationMixin extends Vue {
  @OrganizationsModule.State readonly organizations!: OrganizationDto[];
  @EventsModule.State readonly organizationId!: string | null;

  get isInOrganizerDashboard(): boolean {
    return !!this.$route.name && this.$route.name.startsWith('organizations-id') && this.$route.params.id != null;
  }

  get organization(): OrganizationDto | null {
    const orgId = this.isInOrganizerDashboard ? this.$route.params.id : this.organizationId || null;
    return this.organizations.find(({ id }) => id === orgId) || null;
  }
}
